// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      jobId: string,
      itemId: string,
    },
  },
};

const mutation = graphql`
  mutation AddJobLinkedItemMutation($input: AddJobLinkedItemInput!) {
    addJobLinkedItem(input: $input) {
      jobEdge {
        ...JobsTable_jobEdges
        node {
          id
          importJobNumber
          jobNumber
          name
          status
          linkedItems(first: null) {
            edges {
              usageQty
              node {
                id
                itemNumber
                name
                upc
                partNumber
                description
                category {
                  id
                  name
                }
                quantityUOM {
                  id
                  name
                  type
                  symbol
                }
                weightUOM {
                  id
                  name
                  type
                  symbol
                }
                dimensionUOM {
                  id
                  name
                  type
                  symbol
                }
                formFieldValues
                dimensionLength
                dimensionWidth
                dimensionHeight
                weight
              }
            }
          }
          yields(first: null) {
            totalCount
            edges {
              node {
                id
                finalQuantity
              }
            }
          }
          user {
            id
            firstName
            lastName
          }
          order {
            id
            promisedAt
            orderNumber
            status
            customer {
              id
              name
            }
          }
          workflow {
            id
            name
          }
          states {
            id
            workflowState {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: MutationOptions) => {
    const { jobId } = options.variables.input;

    return createRelayMutation(mutation, {
      ...options,
      updater: store => {
        // Traverse the mutation response until we find the updated job linkedItems edge
        const updatedJobLinkedItemEdges = store
          .getRootField('addJobLinkedItem')
          .getLinkedRecord('jobEdge')
          .getLinkedRecord('node')
          .getLinkedRecord('linkedItems')
          .getLinkedRecords('edges');

        // Retrieve the root job query
        const root = store.getRoot().getLinkedRecord('job', {
          id: jobId,
        });

        // Retrieve the root job query's linkedItems array
        const conn = ConnectionHandler.getConnection(root, 'Job_linkedItems');

        conn.setLinkedRecords(updatedJobLinkedItemEdges, 'edges');
      },
    });
  },
};
